import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import { Grid } from '@mui/material'
import * as category from '../../appRedux/actions/category'
import * as common from '../../appRedux/actions/common'
import ProductBox from '../../components/product_box'
import * as router from '../../constants/router'
import Loading from '../../components/loading'
import Header from '../../components/header'
import * as util from '../../util'

function CategoryDetails(props) {
    let { id } = useParams()
    id = id.replace(':id', '')

    useEffect(() => {
        emptyId()
        categoryDetails()
    }, [])

    const emptyId = () => {
        if (id === "") {
            props.redirectAction(router.HOME)
        }
    }

    const categoryDetails = () => {
        if (id !== "") {
            props.categoryDetailsAction(id)
        }
    }

    const getType = () => {
        let type = 'video'
        if (id === "3") type = 'subdir'
        return type
    }

    const getDirType = () => {
        let dirType = 'video'
        if (id === "3") dirType = 'dir'
        return dirType
    }

    return (
        <React.Fragment>
            <Header title={util.getCategoryDetailsTitle(id)} redirectLink={router.HOME} />
            {props.loadingPage ? <Loading /> :
                <Grid container spacing={4}>
                    {props.data.map((obj, index) => (
                        <Grid key={index} item xs={6} md={3}>
                            <ProductBox dirType={getDirType()} {...obj} type={getType()} categoryId={id} />
                        </Grid>
                    ))}
                </Grid>
            }
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        data: state.common.data,
        loadingPage: state.common.loadingPage
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        redirectAction: (router) => dispatch(common.redirectAction(router)),
        categoryDetailsAction: (id) => dispatch(category.categoryDetailsAction(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryDetails)
